if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.paymentButton = this.querySelector('.shopify-payment-button');
        this.customizeUrl = this.dataset.customizeUrl;
        this.customizeLabel = this.dataset.customizeLabel || 'Customize bij Orbea';
        this.customizeVariants = this.getCustomizeVariants();
        this.orbeaConfigurationState = {
          variantId: '',
          stockMatch: false,
          requiresCustomize: false,
          myoDesignLinked: false,
          lineItemProperties: {},
          customizeUrl: this.customizeUrl,
          testMode: false,
          priceCents: 0,
          carrierVariantId: '',
        };
        this.addEventListener('orbea:configuration-state', (event) => {
          const detail = event.detail || {};
          if (String(detail.variantId || '') !== String(this.productVariantId || '')) return;
          this.orbeaConfigurationState = {
            variantId: String(detail.variantId || ''),
            stockMatch: Boolean(detail.stockMatch),
            requiresCustomize: Boolean(detail.requiresCustomize),
            myoDesignLinked: Boolean(detail.myoDesignLinked),
            lineItemProperties: detail.lineItemProperties || {},
            customizeUrl: detail.customizeUrl || this.customizeUrl,
            testMode: Boolean(detail.testMode),
            priceCents: Number(detail.priceCents || 0),
            carrierVariantId: String(detail.carrierVariantId || ''),
          };
          this.updateCustomizeButton();
        });

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.updateCustomizeButton();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.isCustomizeVariant()) {
          window.open(this.orbeaConfigurationState.customizeUrl || this.customizeUrl, '_blank', 'noopener,noreferrer');
          return;
        }

        this.syncOrbeaProperties();

        if (this.orbeaConfigurationState.testMode) {
          const testFormData = new FormData(this.form);
          this.applyOrbeaCarrier(testFormData);
          this.appendOrbeaProperties(testFormData);
          this.dataset.orbeaTestPayload = JSON.stringify(Array.from(testFormData.entries()));
          this.handleErrorMessage('Testversie: de winkelwagen wordt pas bij de livegang geactiveerd.');
          return;
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (!this.applyOrbeaCarrier(formData)) {
          this.handleErrorMessage('Deze configuratie kan nog niet veilig worden geprijsd. Probeer het later opnieuw.');
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.classList.remove('loading');
          this.querySelector('.loading__spinner').classList.add('hidden');
          return;
        }
        this.appendOrbeaProperties(formData);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }

        this.updateCustomizeButton();
      }

      getCustomizeVariants() {
        const customizeVariants = this.querySelector('[data-customize-variants]');
        if (!customizeVariants) return {};

        try {
          return JSON.parse(customizeVariants.textContent) || {};
        } catch (error) {
          console.error(error);
          return {};
        }
      }

      syncOrbeaProperties() {
        const properties = this.orbeaConfigurationState.lineItemProperties || {};
        this.form.querySelectorAll('[data-orbea-property]').forEach((input) => input.remove());
        for (const [key, value] of Object.entries(properties)) {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = `properties[${key}]`;
          input.value = String(value);
          input.setAttribute('value', String(value));
          input.dataset.orbeaProperty = 'true';
          this.form.appendChild(input);
        }
      }

      appendOrbeaProperties(formData) {
        const properties = this.orbeaConfigurationState.lineItemProperties || {};
        for (const [key, value] of Object.entries(properties)) {
          formData.set(`properties[${key}]`, String(value));
        }
      }

      applyOrbeaCarrier(formData) {
        if (!this.orbeaConfigurationState.variantId || this.orbeaConfigurationState.stockMatch) return true;
        if (!this.orbeaConfigurationState.carrierVariantId) return false;
        formData.set('id', this.orbeaConfigurationState.carrierVariantId);
        return true;
      }

      isCustomizeVariant() {
        if (!(this.orbeaConfigurationState.customizeUrl || this.customizeUrl)) return false;
        if (this.orbeaConfigurationState.stockMatch) return false;
        if (String(this.orbeaConfigurationState.variantId || '') === String(this.productVariantId || '')) {
          return this.orbeaConfigurationState.requiresCustomize;
        }
        return Boolean(this.customizeVariants[String(this.productVariantId)]);
      }

      updateCustomizeButton() {
        if (!this.submitButton || !this.submitButtonText) return;

        const isCustomizeVariant = this.isCustomizeVariant();
        this.submitButton.classList.toggle('product-form__submit--customize', isCustomizeVariant);
        if (this.paymentButton) this.paymentButton.hidden = isCustomizeVariant;

        if (!isCustomizeVariant) {
          this.submitButtonText.textContent = window.variantStrings.addToCart;
          if (this.orbeaConfigurationState.stockMatch || this.orbeaConfigurationState.myoDesignLinked) {
            this.submitButton.removeAttribute('disabled');
            this.submitButton.removeAttribute('aria-disabled');
          }
          return;
        }

        this.submitButton.removeAttribute('disabled');
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.classList.remove('loading');
        this.submitButtonText.classList.remove('hidden');
        this.submitButtonText.textContent = this.customizeLabel;
        this.querySelector('.loading__spinner')?.classList.add('hidden');
      }

      get productVariantId() {
        return this.variantIdInput?.value;
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
